module.exports = "/_next/static/images/ac14bd0398fcf24ddc105c06e22f6e3e-bars-md.jpg";